import { client } from '@/common-utils/libraries/axios/axios';
import PAYLUDD_SUBSCRIPTIONS from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationTerminatePayluddSubscription = (onSuccess, onError) => {
    return {
        mutationFn: ({ subscriptionId }) => {
            return client.post(
                replaceParameters(PAYLUDD_SUBSCRIPTIONS.TERMINATE.url, { subscriptionId })
            );
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationTerminatePayluddSubscription;
